import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { FC, MouseEventHandler, ReactNode } from "react";
import { EIconNames } from "src/shared/types/iconNames";
import { IconButton, MenuComponent } from "../..";
import { IMenuItem } from "../../MenuComponent/model/types";

export interface IDrawerHeaderProps {
  title?: string;
  headerStatus?: ReactNode;
  children?: ReactNode;
  headerActionId?: string;
  headerActionItems?: IMenuItem[];
  hasShadow?: boolean;
  titleOverflowVisible?: boolean;
  onCrossClick?: MouseEventHandler<HTMLButtonElement>;
}

const DrawerHeader: FC<IDrawerHeaderProps> = ({
  children,
  headerStatus,
  title,
  hasShadow,
  onCrossClick,
  titleOverflowVisible,
  headerActionId = "",
  headerActionItems = [],
}) => {
  const renderContent = (): ReactNode => {
    if (children) {
      return children;
    }
    if (title) {
      return (
        <Typography
          variant="h6"
          noWrap={!titleOverflowVisible}
          sx={{
            fontWeight: 400,
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>
      );
    }
  };

  return (
    <Box
      className="drawer-header"
      sx={{
        py: 4,
        pl: 4.5,
        pr: 4,
        gap: 3,
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        boxShadow: hasShadow ? 6 : "none",
        borderBottom: !hasShadow ? "1px solid" : "none",
        borderColor: !hasShadow ? "grey.200" : "transparent",
      }}
    >
      {onCrossClick && (
        <IconButton
          sx={{
            mt: 0.75,
            flexShrink: 0,
            marginLeft: "auto",
            padding: "6px!important",
            ["& .icons"]: {
              color: "text.primary",
            },
          }}
          iconName={EIconNames.CROSS}
          color="secondary"
          onClick={onCrossClick}
        />
      )}
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          className: "drawer-header-content",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        {renderContent()}
      </Box>
      <Box sx={{ height: "100%" }}>
        <Box sx={{ display: "flex", columnGap: 3, alignItems: "center" }}>
          {headerStatus && (
            <Box sx={{ maxWidth: (theme) => theme.spacing(50) }}>
              {headerStatus}
            </Box>
          )}
          {headerActionId && headerActionItems && (
            <MenuComponent id={headerActionId} menuItems={headerActionItems} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DrawerHeader;
